import { createRoute } from '@tanstack/react-router';

import { AdminBaseRouteLayout } from '$/routes/Admin/AdminBaseRouteLayout';

export const AdminProducersRoute = createRoute({
  getParentRoute: () => AdminBaseRouteLayout,
  path: '/admin/producers',
}).lazy(() => import('./AdminProducersRoute.lazy').then((d) => d.Route));
